import moment from "moment";

import { useLanguage } from "~/contexts/providers/language";
import { EventType } from "~/types/event/event.types";

moment.updateLocale("en", { week: { dow: 1 } });

export const orderByWeek = (events: EventType[]) => {
  const { language } = useLanguage();
  const mappedEvents: {
    [key: string]: {
      header: string;
      data: EventType[];
      date: Date;
    };
  } = {};

  for (const event of events) {
    const dateFrom = moment(event.dateFrom);
    const week = dateFrom.week();
    const year = dateFrom.year();
    const monday = dateFrom.startOf("day").clone().weekday(0);
    const sunday = dateFrom.startOf("day").clone().weekday(6);
    const index = `${year}-${week}`;

    if (mappedEvents[index]) {
      mappedEvents[index].data.push(event);
    } else {
      mappedEvents[index] = {
        header:
          language === "En"
            ? `${monday.format("MMM")} ${monday.date()} → ${sunday.format(
                "MMM"
              )} ${sunday.date()} `
            : `${monday.date()} ${monday.format(
                "MMM"
              )} → ${sunday.date()} ${sunday.format("MMM")}`,
        data: [event],
        date: new Date(event.dateFrom),
      };
    }
  }
  return mappedEvents;
};
